import * as v from "valibot"

export const CENTRA_LANGUAGE_CODE = {
    En: "en",
    De: "de",
    Fr: "fr",
    Ja: "ja"
} as const

export type CentraLanguageCode =
    (typeof CENTRA_LANGUAGE_CODE)[keyof typeof CENTRA_LANGUAGE_CODE]

export const LanguageCodeSchema = v.picklist(
    Object.values(CENTRA_LANGUAGE_CODE) as [CentraLanguageCode, ...CentraLanguageCode[]]
)

export const validateLanguageCode = (code: string) => {
    return v.safeParse(LanguageCodeSchema, code)
}

export interface LanguageOption {
    language: CentraLanguageCode
    label: string
    path?: string
    /**
     * `true` while the locale exists in config but is not public yet. Preview locales are
     * invisible to public traffic (they behave exactly like a locale that was never
     * configured) and are reachable only in Sanity draft mode. Absent means live.
     */
    preview?: boolean
}

export const getLanguageLabel = (lang: CentraLanguageCode): string => {
    const labels: Record<CentraLanguageCode, string> = {
        [CENTRA_LANGUAGE_CODE.De]: "German",
        [CENTRA_LANGUAGE_CODE.En]: "English",
        [CENTRA_LANGUAGE_CODE.Fr]: "French",
        [CENTRA_LANGUAGE_CODE.Ja]: "Japanese"
    }
    return labels[lang]
}

export const languages: LanguageOption[] = Object.values(CENTRA_LANGUAGE_CODE).map(
    lang => ({
        language: lang,
        label: getLanguageLabel(lang)
    })
)
